/**
 * Builds object to be used as parameters for OData request.
 * @param filters Array of strings with filter expressions.
 * @param orderBy Array of objects with fields 'property' and 'dir'.
 * @param skip
 * @param top
 * @param select
 * @param format
 * @param count
 * @param expand
 * @returns {{$format: string, $count: boolean, $skip: number, $top: number, $filter: string, $orderby: string}}
 */
function buildParams(filters = [], orderBy = [], skip = 0, top = 20, select = [], expand = [],
                                    format = 'json', count = true) {
	const d = {
		$format: format,
		$count: count
	};
	if (top > 0) {
		d.$top = top;
	}
	if (skip > 0) {
		d.$skip = skip;
	}
	if (orderBy && orderBy.length > 0) {
		d.$orderby = orderBy.map(v => v.property + " " + v.dir).join();
	}

	// search / filtering
	if (filters && filters.length > 0) {
		d.$filter = filters.join(" and ");
	}

	if (select && select.length > 0) {
		d.$select = select.join();
	}

	if (expand && expand.length > 0) {
		d.$expand = expand.join();
	}

	return d;
}

function convertValue(value) {
	if (typeof value === 'string') {
		return `'${value}'`;
	}
	if (typeof value === 'number' || typeof value === 'boolean') {
		return '' + value;
	}
	if (value instanceof Date && !isNaN(value.valueOf())) {
		return value.toISOString();
	}
	return '' + value;
}

const filters = {
	contains: function (fieldName, value) {
		return `indexof(${fieldName},${convertValue(value)}) gt -1`;
	},
	startsOrEndsWith: function (fieldName, value) {
		const firstDollar = value.indexOf('$') === 0;
		const lastDollar = value.lastIndexOf('$') === value.length - 1;
		if (firstDollar && lastDollar)
			return `${fieldName} eq ${convertValue(value.substr(1).slice(0, -1))}`;
		if (firstDollar)
			return `startswith(${fieldName},${convertValue(value.substr(1))}) eq true`;
		if (lastDollar)
			return `endswith(${fieldName},${convertValue(value.slice(0, -1))}) eq true`;
		else
			return `indexof(${fieldName},${convertValue(value)}) gt -1`;
	},
	anyContains: function (fieldName, value, propName = '') {
		if (propName) propName = '/' + propName;
		return `${fieldName}/any(x: indexof(x${propName},${convertValue(value)}) gt -1)`
	},
	anyStartsOrEndsWith: function (fieldName, value, propName = '') {
		if (propName) propName = '/' + propName;
		return `${fieldName}/any(x: ${startsOrEndsWith('x' + propName, value)})`
	},
	equals: function (fieldName, value, propName = '') {
		if (propName) propName = '/' + propName;
		return `${fieldName}${propName} eq ${convertValue(value)}`;
	},
	anyEquals: function (fieldName, value, propName = '') {
		if (propName) propName = '/' + propName;
		return `${fieldName}/any(x: x${propName} eq ${convertValue(value)})`
	},
	between: function (fieldName, from, to) {

	},
	or: function (filterConditions) {
		return `(${filterConditions.join(' or ')})`
	}
};

export default {
    buildParams,
	filters
};


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/odata.js